define('modules/common/service/LocalStorage',[], function() {
    var Service = function() {

        var getItem = function($key, defaultValue) {
            defaultValue = defaultValue || null;
            var item = localStorage.getItem($key);
            return item ? JSON.parse(item) : defaultValue;
        };

        var setItem = function($key, $value) {
            localStorage.setItem($key, JSON.stringify($value));
        };

        var removeItem = function($key) {
            localStorage.removeItem($key);
        };

        var clear = function() {
            localStorage.clear();
        };

        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem,
            clear: clear
        };
    };

    return [Service];
});
